import { type CSSProperties, type NestedCSSProperties } from 'typestyle/lib/types';
import StyleConstants from '../../styles.constants';

export const input = (disabled?: boolean, hasIcon?: boolean): NestedCSSProperties => ({
  marginTop: 8,
  marginBottom: 8,
  padding: 8,
  paddingLeft: hasIcon ? 40 : 16,
  border: '1px solid rgba(36, 55, 75, 0.2)',
  borderRadius: 8,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  color: StyleConstants.GREY_COLOR,
  height: 36,
  width: '100%',
  backgroundColor: disabled ? StyleConstants.DISABLED_BACKGROUND_COLOR : StyleConstants.WHITE_COLOR,
  $nest: {
    '&::placeholder': {
      color: StyleConstants.GREY_COLOR,
    },
    '&::-ms-reveal': {
      display: 'none',
    },
    '&::-ms-clear': {
      display: 'none',
    },
  },
});

export const icon: CSSProperties = {
  cursor: 'pointer',
  position: 'absolute',
  top: 12,
  right: 10,
};
